import React from "react";
import { Star, Scale, Landmark, Languages } from "lucide-react";
import { UI } from "@/content/site";
import { useGoogleRating, googleChipLabel } from "@/hooks/useGoogleRating";

export default function TrustBar({ lang }) {
  const ui = UI[lang];
  // [Phase 26] Live Google chip — shows the real rating/count from the
  // Places snapshot so the trust bar can never contradict the
  // AggregateRating JSON-LD. Neutral fallback while loading/unavailable.
  const live = useGoogleRating(lang);
  const items = [
    { Icon: Star, label: googleChipLabel(live, lang, ui.trustGoogle), testId: "trust-google-chip" },
    { Icon: Scale, label: ui.trustSuperLawyers },
    { Icon: Landmark, label: ui.trustConsulate },
    { Icon: Languages, label: ui.trustBilingual },
  ];
  return (
    <div
      className="gw-trust-bar"
      data-testid="trust-bar"
      style={{
        background: "#fff",
        padding: "var(--gw-space-6) 0",
        borderTop: "1px solid var(--gw-border)",
        borderBottom: "1px solid var(--gw-border)",
      }}
    >
      <div className="gw-container" style={{
        display: "flex", flexWrap: "wrap", justifyContent: "center",
        gap: "var(--gw-space-8)", alignItems: "center", textAlign: "center",
      }}>
        {items.map(({ Icon, label, testId }) => (
          <div key={label} data-testid={testId} style={{display: "inline-flex", alignItems: "center", gap: 10, color: "var(--gw-text-soft)", fontWeight: 600, fontSize: "0.95rem"}}>
            <Icon size={18} strokeWidth={2} aria-hidden="true" style={{color: "var(--gw-primary)", flexShrink: 0}} />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
